module.exports = __webpack_public_path__ + "static/img/5-CN.5a6f15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/5-CN.png
// module id = MVgV
// module chunks = 1